<ng-template [ngIf]="isComunicandoInvioInfratel">
  <app-loading></app-loading>
</ng-template>
<div class="d-flex mt-1 ">
  <form [formGroup]="comunicaInvioInfratelForm">
    <div class="grid formgrid p-fluid ">
      <div class="field col">
        <label for="dataInvio" >Data invio ad INFRATEL</label>
        <p-calendar
            formControlName="dataInvio"
            id="dataInvio"
            [showIcon]="true"
            dateFormat="dd/mm/yy"
            placeholder="Data invio"
            [appendTo]="'body'"
          ></p-calendar>
      </div>
   </div>
</form>
</div>
  <div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
    <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
    styleClass="p-button-warning"></p-button>
   <p-button  icon="pi pi-check" label="Conferma"
    class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isComunicandoInvioInfratel || !comunicaInvioInfratelForm.valid"></p-button>
</div>

